import { render } from "./Document.vue?vue&type=template&id=339efe7e&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=339efe7e&lang=scss&scoped=true"

import exportComponent from "/home/app/rails/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339efe7e"]])

export default __exports__